<template>
  <content-page kind="article"/>
</template>
<script>import ContentPage from './content-page';

export default {components: {ContentPage}}</script>
